/**
 * Created by Jerker Nord on 2018-05-22.
 */

export class IceIceYetiWildPresentationEvent {
    public static readonly CRACK_ICE:string = "iceIceYetiWildPresentationEvent_crackIce";
}